// extracted by mini-css-extract-plugin
export default {"hideTooltip":"X9-z","fadeIn":"Y9-z","delay":"Z9-z","recommendedSizeTooltip":"_9-z"};